// not applicable in the browser so we just return a noop function

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function keepAlive(): void {}
